import React from 'react';
import { Layout } from '@/components/Layout';
import { MatchBettingPanel } from '@/components/MatchBetting';

/**
 * Match Betting Page
 * Provides the interface for users to browse football matches, select dates,
 * and place bets. For Company users, it includes administrative match controls.
 * Current Date: 2026-02-09
 */
const MatchBetting: React.FC = () => {
  return <Layout>
      {/* Match Betting fills the full page with no gaps */}
      <MatchBettingPanel />
    </Layout>;
};
export default MatchBetting;